<!--
  Header chrome (icon/count/mute/"turn on sound") now lives on the dock
  that hosts this component (RequestsTasksDock) — see request-alerts.html's
  identical note. Body-only content now: the orders list, or an empty
  state. The round/ring escalation logic in order-approval-strip.ts is
  untouched — only this template shrank.
-->
<div class="nv-strip" role="status">
  @if (count() === 0) {
    <div class="nv-strip__empty">
      <p class="nv-strip__empty-title">Nothing waiting</p>
      <!-- Item 28 — this strip is the dock's ORDERS tab, not its Tasks tab
           (they were one tab before Orders was split out); the old copy
           still talked about tasks for the shift. -->
      <p class="nv-strip__empty-note">Every order has been reviewed.</p>
    </div>
  } @else {
    <div class="nv-strip__orders nvx-scroll">
      @for (order of ordered(); track order.id) {
        <div class="nv-strip__order">
          <span class="nv-strip__order-label">Table {{ tableLabel(order.tableId) }} · ₹{{ (order.totalMinor / 100).toFixed(2) }}</span>
          <div class="nv-strip__order-actions">
            <!-- Item 8: no blind "Approve" any more — this always opens the
                 item picker first (approveSome, despite the name, is also
                 the path a full approval takes when every line stays
                 ticked; see ApproveOrderDialogResult's own doc comment). A
                 manager could previously approve without ever seeing what
                 the guest ordered. "Show items" names what the button
                 actually does — the commit itself happens inside the
                 dialog once the manager has seen the order. Reject sits
                 beside it for the outright-decline case (e.g. a kitchen
                 timing issue) without opening the item list first. -->
            <button type="button" nvButton="primary" size="xs" (click)="approveSome(order)">Show items</button>
            <button type="button" nvButton="text" size="xs" (click)="reject(order)">Reject</button>
          </div>
        </div>
      }
    </div>
  }
</div>
